var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiWand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_ai_wand)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.68165 3.55058C4.97454 3.25768 5.44941 3.25768 5.74231 3.55058L13.1669 10.9752C13.4597 11.2681 13.4598 11.743 13.1669 12.0359L12.0351 13.1676C11.7423 13.4604 11.2674 13.4604 10.9745 13.1676L3.54986 5.74302C3.257 5.45016 3.25707 4.97526 3.54986 4.68236L4.68165 3.55058ZM4.49935 4.83911C4.35295 4.98551 4.35305 5.22299 4.49935 5.36944L5.58141 6.45151C5.72786 6.59796 5.9653 6.59796 6.11174 6.45151L6.45149 6.11177C6.59793 5.96532 6.59793 5.72788 6.45149 5.58144L5.36942 4.49937C5.22296 4.35307 4.98549 4.35297 4.83909 4.49937L4.49935 4.83911Z",
    fill: "#002A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83363 12.3821C4.8794 12.5521 5.1206 12.5521 5.16637 12.3821C5.32601 11.7892 5.78917 11.326 6.3821 11.1664C6.5521 11.1206 6.5521 10.8794 6.3821 10.8336C5.78917 10.674 5.32601 10.2108 5.16637 9.6179C5.1206 9.4479 4.8794 9.4479 4.83363 9.6179C4.67399 10.2108 4.21083 10.674 3.6179 10.8336C3.4479 10.8794 3.4479 11.1206 3.6179 11.1664C4.21083 11.326 4.67399 11.7892 4.83363 12.3821Z",
    fill: "#002A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8391 6.90228C10.8833 7.06673 11.1167 7.06673 11.1609 6.90228L11.2809 6.45689C11.4353 5.88332 11.8833 5.43529 12.4569 5.28085L12.9023 5.16093C13.0667 5.11666 13.0667 4.88334 12.9023 4.83906L12.4569 4.71914C11.8833 4.56471 11.4353 4.11668 11.2809 3.54311L11.1609 3.09772C11.1167 2.93327 10.8833 2.93327 10.8391 3.09772L10.7191 3.54311C10.5647 4.11668 10.1167 4.56471 9.54311 4.71915L9.09772 4.83906C8.93327 4.88334 8.93327 5.11666 9.09772 5.16094L9.54311 5.28086C10.1167 5.43529 10.5647 5.88332 10.7191 6.45689L10.8391 6.90228Z",
    fill: "#002A69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41682 4.19105C8.4397 4.27605 8.5603 4.27605 8.58318 4.19105C8.66301 3.89458 8.89458 3.66301 9.19105 3.58318C9.27605 3.5603 9.27605 3.4397 9.19105 3.41682C8.89458 3.33699 8.66301 3.10542 8.58318 2.80895C8.5603 2.72395 8.4397 2.72395 8.41682 2.80895C8.33699 3.10542 8.10542 3.33699 7.80895 3.41682C7.72395 3.4397 7.72395 3.5603 7.80895 3.58318C8.10542 3.66301 8.33699 3.89458 8.41682 4.19105Z",
    fill: "#002A69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_ai_wand"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiWand);
export default __webpack_public_path__ + "static/media/Ai_wand.3c193986558c099a90ea57795b635e7e.svg";
export { ForwardRef as ReactComponent };